export function isStaging() {
  return process.env.NEXT_PUBLIC_DEPLOY_ENV === 'staging';
}
